export default __webpack_public_path__ + "static/media/image-52.c69f27eb.png";